import { HostingFilters } from './HostingFilters';
import { OtherFilters } from './OtherFilters';
import { PricingFilters } from './PricingFilters';
import { ProductFilters } from './ProductFilters';
import { TrustFilters } from './TrustFilters';
const SearchFilters = _ref => {
  let {
    showCompassApps,
    showTrelloProductFilter
  } = _ref;
  return {
    product: {
      options: ProductFilters({
        showCompassApps,
        showTrelloProductFilter
      }),
      error: null
    },
    hosting: {
      options: HostingFilters(),
      error: null
    },
    price: {
      options: PricingFilters(),
      error: null
    },
    trustSignals: {
      options: TrustFilters(),
      error: null
    },
    other: {
      options: OtherFilters(),
      error: null
    }
  };
};
export default SearchFilters;